/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'check-strong': {
    width: 33,
    height: 26,
    viewBox: '0 0 33 26',
    data: '<defs><linearGradient id="svgicon_check-strong_a" x1="66.679%" x2="33.358%" y1="49.997%" y2="49.997%"><stop offset="0%"/><stop offset="100%"/></linearGradient></defs><path pid="0" _fill="url(#svgicon_check-strong_a)" d="M10.162 26c-.761 0-1.522-.26-2.03-1.04L.52 15.6c-.762-1.04-.762-2.6.507-3.64 1.015-1.04 2.791-.78 3.553.26l5.836 7.28L28.686.78c1.015-1.04 2.538-1.04 3.553 0 1.015 1.04 1.015 2.6 0 3.64l-20.3 20.8c-.508.52-1.016.78-1.777.78z"/>'
  }
})
